import { FormApi } from 'final-form'
import React from 'react'

import { IFilter, IFilterType } from '../../../types'
import RenderFilterMode from './FilterMode'
import FilterType from './FilterType'

type TSetFilter = (filter: IFilter) => void
interface FilterRendererProps extends IFilterType {
  filterMode?: string
  filters?: IFilter[]
  form?: FormApi
  setFilter?: TSetFilter
}

const FilterRenderer = (props: FilterRendererProps): React.ReactElement => {
  const {
    filterMode = '',
    filters = [],
    handleKeyDown,
    setFilter,
    isMobile,
    form,
  } = props

  const renderFilter = (filter: IFilter, index: number): React.ReactElement => {
    return (
      <FilterType
        filter={filter}
        index={index}
        isMobile={isMobile}
        handleKeyDown={handleKeyDown}
      />
    )
  }

  return (
    <RenderFilterMode
      filterMode={filterMode}
      filters={filters}
      renderFilter={renderFilter}
      setFilter={setFilter as TSetFilter}
    />
  )
}

export default FilterRenderer
